import Phaser from 'phaser';
import { PowerUp, PowerUpConfig, WeightClass } from './PowerUp';

export interface HealthPowerUpConfig extends PowerUpConfig {
  /** Amount of health to restore (default: 1) - used by data system */
  healAmount?: number;
}

/**
 * HealthPowerUp - Restores player health
 *
 * From C3: upHealth
 * Effects are handled by data-driven system (powerups-overrides.json)
 */
export class HealthPowerUp extends PowerUp {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string = 'uphealth',
    config: HealthPowerUpConfig = {}
  ) {
    super(scene, x, y, texture, {
      ...config,
      weight: config.weight ?? WeightClass.Light,
      bioMatter: config.bioMatter ?? 0,
    });
  }
}
